import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWidgetSettingsComponent } from '../../widget/base/base-widget';
import { IMachineViewWidgetConfig } from '../machine-view.component';
import { DxButtonModule, DxFormModule, DxPopupModule } from 'devextreme-angular';
import { WidgetDataService } from '../../widget/data/widget-data.service';
import { MachineInfoMainService } from 'src/app/shared/services/machine-info.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MachineInfo } from 'src/api/generated';

@Component({
  selector: 'app-machine-view-settings',
  standalone: true,
  imports: [CommonModule, DxFormModule, DxButtonModule, DxPopupModule],
  templateUrl: './machine-view-settings.component.html',
  styleUrl: './machine-view-settings.component.scss'
})
export class MachineViewSettingsComponent extends BaseWidgetSettingsComponent<IMachineViewWidgetConfig> implements OnInit, OnDestroy {
  public selectOptions: {id: number; name: string;}[] = [];

  private _unsubscriber: Subject<any> = new Subject<any>();

  constructor(
    widgetDataService: WidgetDataService<IMachineViewWidgetConfig>,
    private _miSvc: MachineInfoMainService
  ) {
    super(widgetDataService);
  }

  ngOnInit(): void {
    // Get lidt of machines for select box
    this._miSvc.dataSource.load().then((data) => {
      this.selectOptions = data.map((r: MachineInfo) => {
        return { id: r.Id, name: r.Name };
      });
    });

    // Update form data if options change
    this.widgetDataService.options$.pipe(takeUntil(this._unsubscriber)).subscribe((value) => {
      this.formData = value;
    });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
  }

  /**
   * Form submit method with validation.
   *
   * @memberof MachineViewSettingsComponent
   */
  public override onSubmitModal(): void {
    if (this.formData) {
      this.formData.subtitle = this.formData.machineName ?? '';
    }
    super.onSubmitModal();
  }
}
